import React from 'react';
import './ActivityCardSkeleton.css';

interface ActivityCardSkeletonProps {
  count?: number;
}

/**
 * ActivityCardSkeleton - Loading placeholder for activity cards
 * Shows pulsing gray rectangles matching the card layout
 */
export const ActivityCardSkeleton: React.FC<ActivityCardSkeletonProps> = ({
  count = 1,
}) => {
  return (
    <>
      {Array.from({ length: count }).map((_, index) => (
        <div key={index} className="activity-card-skeleton">
          {/* Header skeleton */}
          <div className="activity-card-skeleton__header">
            <div className="activity-card-skeleton__avatar" />
            <div className="activity-card-skeleton__username" />
          </div>

          {/* Card image skeleton */}
          <div className="activity-card-skeleton__image" />

          {/* Footer skeleton */}
          <div className="activity-card-skeleton__footer">
            <div className="activity-card-skeleton__points" />
            <div className="activity-card-skeleton__timestamp" />
          </div>
        </div>
      ))}
    </>
  );
};

export default ActivityCardSkeleton;
